import {
  Col,
  Row,
  Space,
  Button,
  Popover,
  Table,
  Typography,
  notification,
} from "antd";
import React, {useEffect, useRef, useState} from "react";
import Icons from "assets/icons";
import {manufacturerColumns} from "./ManufacturerCatalog.config";
import ModalCustom from "components/common/ModalCustom/ModalCustom";
import ModalAction from "./ModalAction/ModalAction";
import {ListActionButton, Notification} from "components/common";
import {glassStoreService} from "api";

const ManufacturerCatalog = () => {
  const modalRef = useRef<any>();
  const [columns, setColumns] = useState(manufacturerColumns);
  const [data, setData] = useState([]);
  const [type, setType] = useState("");
  const [total, setTotal] = useState(0);
  const [record, setRecord] = useState(null);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [params, setParams] = useState<any>({
    limit: limit,
    page: currentPage,
  });

  useEffect(() => {
    getList(params);
  }, [params]);

  columns.map(col => {
    if (col.dataIndex == "action") {
      col.render = (value, record, index) => {
        return (
          <ListActionButton
            // key={index}
            deleteFunction={() => deleteAction(record)}
            editFunction={() => {
              setType("Sửa");
              setRecord(record);
              modalRef.current?.openModal();
            }}
          />
        );
      };
    }
  });

  const getList = async params => {
    try {
      const response = glassStoreService
        .getListManufacturer(params)
        .then(res => {
          setData(res.data);
          setTotal(res.total);
        });
    } catch (error) {}
  };
  const onChange = (page, pageSize) => {
    setParams({page: page, limit: pageSize});
  };
  const handleOnAdd = () => {
    setType("Thêm");
    setRecord(null);
    modalRef.current?.openModal();
  };

  const deleteAction = async record => {
    try {
      await glassStoreService.deleteManufacturer(record.id);
      Notification("success", "Xóa thành công");
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi xoá");
    }
  };

  return (
    <div className="container">
      <Space direction="vertical" style={{width: "100%"}} size={"middle"}>
        <Typography.Text className="title" strong>
          Danh mục hãng sản xuất
        </Typography.Text>
        <Row justify={"end"}>
          <Col>
            <Space>
              <Button
                type="primary"
                icon={<Icons.add rev={0} />}
                onClick={handleOnAdd}
              >
                Thêm mới
              </Button>
            </Space>
          </Col>
        </Row>
        <Table
          columns={columns}
          bordered
          dataSource={data}
          scroll={{x: 1500}}
          pagination={{
            total: total,
            onChange: onChange,
          }}
        />
      </Space>
      <ModalCustom ref={modalRef} width={1000} title={`${type} nhà cung cấp`}>
        <ModalAction
          data={record}
          getListStore={getList}
          type={type}
        ></ModalAction>
      </ModalCustom>
    </div>
  );
};

export default ManufacturerCatalog;
